<template>
  <div class="configurator-step-intermission">
    <div v-if="ready" class='chart' v-bind:class="{ loaded: ready }">
      <button @click="restart" class='js-do-it-again'>
        <span class='ion-loop'>X</span>
      </button>

      <div class="description" v-bind:class="{ loaded: ready }">
        Fahrzeugpreis wird berechnet
      </div>

      <svg class="svg-loading-graphic" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 560 260" preserveAspectRatio="none" width="100%" height="100%">
        <defs>
          <filter id='dropshadow'>
            <feGaussianBlur in='SourceAlpha' stdDeviation='3'></feGaussianBlur>
            <feOffset dx='0' dy='0' result='offsetblur'></feOffset>
            <feComponentTransfer>
              <feFuncA slope='0.2' type='linear'></feFuncA>
            </feComponentTransfer>
            <feMerge>
              <feMergeNode></feMergeNode>
              <feMergeNode in='SourceGraphic'></feMergeNode>
            </feMerge>
          </filter>
        </defs>
        <g class='datasets'>
          <path class='dataset' d='M0,260 C0,260 4,252 7,252 C66,252 90,102 139,102 C188,102 205,135 252,135 C299,135 309,89 330,89 C350,89 366,122 404,122 C442,122 431,98 451,98 C470,98 499,213 560,260 L0,259 Z' id='dataset-3'></path>
          <path class='dataset' d='M0,260 C35,254 63,124 88,124 C114,124 148,163 219,163 C290,163 315,100 359,100 C402,100 520,244 560,259 C560,259 0,259 0,260 Z' id='dataset-2'></path>
          <path class='dataset' d='M0,260 C0,260 22,199 64,199 C105,199 112,144 154,144 C195,144 194,126 216,126 C237,126 263,184 314,184 C365,183 386,128 434,129 C483,130 511,240 560,260 L0,260 Z' id='dataset-1'></path>
        </g>
      </svg>
    </div>
	</div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'ConfiguratorStepIntermission',
  props: ['name', 'options'],
  data: function() {
    return {
      finished: false
    }
  },
  methods: {
    restart: function() {
      console.log("restart")
      $(".chart").removeClass("loaded")
      $(".description").removeClass("loaded")
      setTimeout(function() {
        $(".chart").addClass("loaded")
        $(".description").addClass("loaded")
      }, 1000)
    }
  },
  computed: {
    ready() {
      return this.$store.state.options.valuation;
    },
    token() {
      return this.$store.state.token;
    }
  },
  watch: {
    token() {
      if(this.finished) {
        window.location.href = `/auto-verkaufen/schritt-3/${this.token}`;
      }
    },
    ready () {
      if(this.ready) {
        this.$store.dispatch('createLead');
        setTimeout(function() {
          console.log("Intermission finished");
          this.finished = true;
          if(this.token) {
            window.location.href = `/auto-verkaufen/schritt-3/${this.token}`;
          }
        }.bind(this), 2500);
      }
    }
  }
}
</script>

<style lang="sass" scoped>
@import "~@/assets/vars";

@include breakpoint(fromlarge) 
  .svg-loading-graphic 
    background: #f2f2f2


$green: #50E3C2
$blue: #21A6EE
$purple: #807CCC
$navy: #384051
$dot-color: fade-out(white, 0.9)
$text-color: fade-out(white, 0.7)

.configurator-step-intermission
  height: 100%
  background: lighten(#eaf1f8, 5%)
  border-radius: 3px
  margin-top: -40px

button
  z-index: 100
  display: none

.description
  position: absolute
  top: -20px
  left: 0
  right: 0
  bottom: 0
  vertical-align: middle
  text-align: center
  font-size: 24px
  color: #888
  font-weight: 300
  text-shadow: 0px 1px 0px #fff
  opacity: 0
  padding-top: 5%
  transition: all 0.25s ease

.description.loaded
  opacity: 1
  top: 0

svg
  width: 100%
  height: 100%
  position: absolute
  top: 0
  left: 0
  right: 0
  bottom: 0

.chart
  position: relative
  width: 100%
  height: 100%
  // background-image: repeating-radial-gradient(center center, $dot-color, $dot-color 2px, transparent 2px, transparent 100%)
  // background-size: 29px 29px
  // background-position: -11px 11px

.dataset
  fill-opacity: 0.8
  // filter: url(#dropshadow)

#dataset-1
  fill: $green

#dataset-2
  fill: darken($green, 20%)

#dataset-3
  fill: darken($green, 40%)

//---------------------- animations
@keyframes raise
  0%
    transform: scaleY(0.01)
  100%
    transform: scaleY(1)

.dataset
  transform-origin: bottom
  transform: scaleY(0.01)
  opacity: 0.5

.loaded .dataset
  opacity: 1
  animation: raise 1.5s ease 1.2s forwards

.loaded #dataset-1
  animation-delay: 1s

.loaded #dataset-2
  animation-delay: 0.5s

.loaded #dataset-3
  animation-delay: 0s
</style>



// WEBPACK FOOTER //
// src/components/ConfiguratorStepIntermission.vue